import { MinusCircleIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const MinusCircle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <MinusCircleIcon size={Sizes[size]} color={fill || stroke} {...rest} />;
};

MinusCircle.displayName = 'MinusCircle';
